import Utils from './Utils';

class SelectOptions {

  static _getValueMultiple(value, options, index) {
    let result = [];
    value.forEach((item, valueIndex) => {
      if (options) {
        if (index && options[item]) {
          result.push({value:item, label:options[item].value});
        }
        else {
          options.forEach((option, optionIndex) => {
            if (option.value == item) {
              result.push({
                value:index ? optionIndex : option.value,
                label:option.label ? option.label : option.value ? option.value : option
              });
            }
          });
        }
      }
      if (Utils.isNull(result[valueIndex]) && isNaN(item) && index) {
        result.push(item);
      }
    });
    return result;
  };

  static _getValueNormal(value, options, index) {
    let result = null;
    if (options) {
      if (index && options[value]) {
        result = {value:value, label:options[value].value};
      }
      else {
        options.forEach((option, optionIndex) => {
          if (option.value == value) {
            result = {
              value: index ? optionIndex : option.value,
              label: (option.label || (option.value ? option.value : option))
            };
          }
        });
      }
    }
    if (!result) {
      result = (isNaN(value) && index) ? value : null;
    }
    return result;
  };

  static getIndexValue(options, value) {
    let result = null;
    if (Array.isArray(value)) {
      result = this._getValueMultiple(value, options, true);
    }
    else {
      result = this._getValueNormal(value, options, true);
    }
    return result;
  };

  static getValue(options, value) {
    let result = null;
    if (Array.isArray(value)) {
      result = this._getValueMultiple(value, options);
    }
    else {
      result = this._getValueNormal(value, options);
    }
    return result;
  };
}

export default SelectOptions;